export default __webpack_public_path__ + "static/media/06.6bc6cb99.jpeg";